import { loadImageAsDataUrl } from './fixBorderImageForScreenshot';

export async function fixObjectFitForScreenshot(container: HTMLElement): Promise<void> {
    const images = Array.from(container.querySelectorAll<HTMLImageElement>('img'));

    await Promise.all(images.map(async (img) => {
        const computedStyle = getComputedStyle(img);
        const objectFit = computedStyle.objectFit;

        if (!objectFit || objectFit === 'fill') return;

        let dataUrl: string;
        try {
            dataUrl = await loadImageAsDataUrl(img.src);
        } catch {
            return;
        }

        const bgSize =
            objectFit === 'cover' ? 'cover' :
            objectFit === 'contain' || objectFit === 'scale-down' ? 'contain' :
            'auto';

        const div = document.createElement('div');
        div.style.backgroundImage = `url('${dataUrl}')`;
        div.style.backgroundSize = bgSize;
        div.style.backgroundPosition = computedStyle.objectPosition || 'center';
        div.style.backgroundRepeat = 'no-repeat';
        div.style.width = computedStyle.width;
        div.style.height = computedStyle.height;
        div.style.borderRadius = computedStyle.borderRadius;
        div.style.border = computedStyle.border;
        div.style.boxShadow = computedStyle.boxShadow;
        div.style.opacity = computedStyle.opacity;
        div.style.display = 'inline-block';
        div.style.boxSizing = 'border-box';
        div.style.margin = computedStyle.margin;
        div.style.flexShrink = computedStyle.flexShrink;
        div.style.flexGrow = computedStyle.flexGrow;
        div.style.flexBasis = computedStyle.flexBasis;
        div.style.alignSelf = computedStyle.alignSelf;

        img.replaceWith(div);
    }));
}
